<nida-web-site-wrapper headline="Patients archive">
  <nida-web-card [disableHeadline]="true">
    <nida-web-patient-table-archive></nida-web-patient-table-archive>
  </nida-web-card>
</nida-web-site-wrapper>
